import styled from 'styled-components';
import media from '../../../constants/media';
import { pageContainerSpacing, pageMaxWidth } from '../../../constants/theme/theme';

export const PageContainer = styled.div`
	width: 100%;
	margin-inline: auto;
	padding-inline: ${pageContainerSpacing.sm}px;

	${media.tablet`
	padding-inline: ${pageContainerSpacing.md}px;
	`}

	${media.desktopSmall`
	padding-inline: ${pageContainerSpacing.lg}px;
	`}

	@media only screen and (min-width: ${pageMaxWidth}px) {
		max-width: ${pageMaxWidth - pageContainerSpacing.lg * 2}px;
		padding-inline: 0;
	}
`;
